module.exports = __webpack_public_path__ + "static/media/s4.eef4022f.png";